import { MESSAGE_CATEGORY_IDS } from '../../constants/messageCategoryIds'

/**
 * True when a message should use danger styling / trigger danger alerts.
 * @param {object} message - store or normalized message
 * @param {Object<string, object>} messageCategoriesById
 */
export function isDangerMessage (message, messageCategoriesById = {}) {
  if (!message) return false
  const color = message.color
  if (color === 1 || color === '1') return true

  const categoryId = message.categoryId ?? message.category?.id
  if (categoryId === MESSAGE_CATEGORY_IDS.DANGER || String(categoryId) === String(MESSAGE_CATEGORY_IDS.DANGER)) {
    return true
  }

  const category = categoryId != null ? messageCategoriesById[categoryId] : message.category
  const name = String(category?.name || '').toLowerCase()
  return name === 'danger'
}
